import { GuestGetSaleTotalModel } from 'api-hooks/guest';
import { string2money } from 'common/utils/string';
import * as React from 'react';
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryContainer,
  VictoryTheme,
} from 'victory';

interface Props {
  data: GuestGetSaleTotalModel[];
}

export default function SaleChart(props: Props) {
  const { data } = props;

  const maxWidth = React.useMemo(() => data.length * 150, [data.length]);
  const maxValues = React.useMemo(() => {
    const _data = data.map((v) => v.y);
    return Math.max(..._data, 5);
  }, [data]);

  return (
    <VictoryChart
      theme={VictoryTheme.material}
      width={maxWidth}
      height={300}
      padding={{ left: 100, bottom: 36, right: 36, top: 36 }}
      domainPadding={0}
      maxDomain={{ y: maxValues }}
      domain={{ x: [0.6, data.length + 0.5], y: [0, maxValues] }}
      // containerComponent={<VictoryZoomContainer />}
    >
      <VictoryAxis
        crossAxis
        tickValues={data.map((_, index) => index + 1)}
        tickFormat={data.map((v) => v.label)}
      />
      <VictoryAxis dependentAxis />
      <VictoryBar
        data={data}
        x="label"
        y="y"
        style={{ data: { fill: '#5D7B9F' } }}
        padding={0}
        domainPadding={0}
        domain={{ x: [0.6, data.length + 0.5] }}
        barWidth={36}
        cornerRadius={{
          top: 5,
        }}
        alignment="middle"
        containerComponent={<VictoryContainer style={{ overflow: 'scroll' }} />}
        events={[
          {
            target: 'data',
            eventHandlers: {
              onMouseOver: () => {
                return [
                  {
                    target: 'labels',
                    mutation: (props) => {
                      return props.text === string2money(props.datum.y)
                        ? null
                        : { text: string2money(props.datum.y) };
                    },
                  },
                ];
              },
              onMouseOut: () => {
                return [
                  {
                    target: 'labels',
                    mutation: (props) => {
                      return props.text === string2money(props.datum.y)
                        ? null
                        : { text: string2money(props.datum.y) };
                    },
                  },
                ];
              },
            },
          },
        ]}
      />
    </VictoryChart>
  );
}
